<template>
  <layout-block :has-border="false" :width="width">
    <layout-block-section margin="10 0 32px" v-if="pdf" style="padding:16px;width:50%;">
      <a
        :href="pdf.url"
        style="

                display: block;
                text-decoration: none;
                color: #06152F;
                font-size: 14px;
                font-weight: 500;
              "
      >
        <img
          src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/pdf-lg.png"
          width="40px"
          style="margin: 16px 0;"
        />
        <span style="display: block;">
          {{ pdf.label }}
        </span>
      </a>
    </layout-block-section>
    <layout-block-section margin="16px 0 0" :shadow="false" bgColor="transparent">
      <ui-legend
        :label="unsubscribe.body"
        font-size="10px"
        margin="16px 0 0"
        color="#06152F"
        v-if="unsubscribe"
        fontFamily="alt"
      />
      <ui-link :label="unsubscribe.link_label" :href="unsubscribe.link_url" v-if="unsubscribe" fontSize="9px" />
    </layout-block-section>
    <ui-logo :white="false" style="margin-top: 18px;" />
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import UiLogo from '@/components/UI/Logo.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiLink from '@/components/UI/Link.vue'

export default {
  name: 'ReportRadar',
  components: {
    LayoutBlock,
    LayoutBlockSection,
    UiLogo,
    UiLegend,
    UiLink,
  },
  props: {
    pdf: {
      type: Object,
      default: null,
    },
    unsubscribe: {
      type: Object,
      default: null,
    },
    width: {
      type: String,
      default: '95%',
    },
  },
}
</script>
